// extracted by mini-css-extract-plugin
module.exports = {"title":"tinkoff__title","success":"tinkoff__success","fail":"tinkoff__fail","button":"tinkoff__button"};